var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c("el-input", {
            attrs: { size: "mini", placeholder: "请输入", value: _vm.value },
            on: { input: _vm.input }
          }),
          _c("el-button", {
            attrs: { icon: "el-icon-edit-outline", title: "编辑", circle: "" },
            on: {
              click: function($event) {
                _vm.visible = true
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            { name: "drag", rawName: "v-drag:common", arg: "common" }
          ],
          attrs: {
            title: "风电标杆/指导电价(元/千瓦时)",
            visible: _vm.visible,
            modal: false
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.data } },
            _vm._l(_vm.columns, function(col) {
              return _c("el-table-column", {
                key: col.prop,
                attrs: {
                  prop: col.prop,
                  label: col.label,
                  width: col.width,
                  align: "center"
                }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }